// extracted by mini-css-extract-plugin
export default {"column":"ProductPrices_column__8OOII","inline":"ProductPrices_inline__MTgOz"};